import { PATHS_NAME } from '@shared/routers/consts/pathsName.js';

const DESCRIPTION = 'Уникальное закрытое криптосообщество DropsCapital. Аналитика, ресерчи, идеи, подкасты от команды Drops Analytics и Sergey (ICO Drops).';

export const ROUTES_META = {
  [PATHS_NAME.MAIN]: {
    title: 'DropsCapital - Самое Боярское Криптосообщество', 
    description: DESCRIPTION,
  },
  [PATHS_NAME.CALENDAR]: {
    title: 'Календарь - DropsCapital', 
    description: DESCRIPTION,
  },
  [PATHS_NAME.FORECASTERS]: {
    title: 'Форкасты - DropsCapital', 
    description: DESCRIPTION, 
  },
  [PATHS_NAME.SIGNALS]: {
    title: 'Сигналы - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.SCANNER]: {
    title: 'Скриннер - DropsCapital', 
    description: DESCRIPTION,
  },
  [PATHS_NAME.STOREROOM]: {
    title: 'Кладовая - DropsCapital', 
    description: DESCRIPTION,
  },
  [PATHS_NAME.TWITTER_HYPE]: {
    title: 'Твиттер Хайп', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.RULES.TERMS]: {
    title: 'Условия использования - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.RULES.PRIVACY]: {
    title: 'Политика конфиденциальности - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.ARTICLES]: {
    title: 'Drops Capital - Самое Боярское Криптосообщество', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.MAIN]: {
    title: 'Личный кабинет Drops Capital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.SETTINGS]: {
    title: 'Настройки - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.COMMENTS]: {
    title: 'Комментарии - DropsCapital',
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.SUBSCRIPTION]: {
    title: 'Подписка - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.GIFT]: {
    title: 'Активация подарочных кодов - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.GIVE_GIFT]: {
    title: 'Подарить подписку - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.SUBSCRIPTION_PURCHASE]: {
    title: 'Подписка - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.SUBSCRIPTION_WALLETS]: {
    title: 'Подписка - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.USER.ALPHA]: {
    title: 'Мнения пользователя - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.KNOWLEDGE_BASE]: {
    title: 'База знаний - DropsCapital', 
    description: DESCRIPTION,  
  },
  [PATHS_NAME.POLYMARKET]: {
    title: 'Polymarket - DropsCapital',
    description: DESCRIPTION,
  },
  [PATHS_NAME.PORTFOLIOS]: {
    title: 'Портфели комьюнити - DropsCapital',
    description: DESCRIPTION,
  },
}